import Color from 'color';

export const BASELINE_COLORS = {
  COLOR: Color('#d066d4'),
  OVERLAY: Color('#d066d4').alpha(0.3),
};

export const COMPARISON_COLORS = {
  COLOR: Color('#1398f6'),
  OVERLAY: Color('#1398f6').alpha(0.3),
};
